<template>
    <v-app>
        <v-overlay :value="loading" :opacity=".95" >
            <v-progress-circular
                    indeterminate
                    :size="100"
                    color="white"
            ></v-progress-circular>
        </v-overlay>
        <v-main v-if="this.error">
            <v-container class="mt-8" >
                <v-row align="center" justify="center">
                    <v-col cols="5">
                        <v-alert outlined type="error">A key was not provided. Could not retrieve file.</v-alert>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>

        <v-main v-if="!this.error">
            <v-container class="mt-8">
                <v-row
                        align="center"
                        justify="center"
                >
                    <v-col
                            cols="5"
                    >
                        <v-card class="elevation-12">
                            <v-card-title>File Downloaded</v-card-title>
                            <v-card-text>
                                <p>The requested file has been downloaded.</p>
                                <p>Check in the downloads folder on your computer to access it.</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    import { Storage } from 'aws-amplify';

    export default {
        name: "Resolve",
        props: ['s3Key'],
        data: () => ({
            loading: true,
            error: false
        }),
        async created() {
            if (!this.s3Key){
                this.loading = false;
                this.error = true;
            } else {
                console.log(unescape(this.s3Key));
                let s3Key = unescape(this.s3Key);
                let baseURL = 'https://teamtri-clientportal223031-prod.s3.us-east-2.amazonaws.com/public/';
                window.onload = function () {
                  window.location.href = baseURL + s3Key;
                }

            }
        }
    }
</script>

<style scoped>

</style>